import { Component, OnInit, Input } from '@angular/core';
import { imgCardDrop } from '../../classes/animations';
import { FormControl } from '@angular/forms';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { AlertService } from '../../services/alert.service';
import { StorageService } from '../../services/storage.service';
import { TRANSLATE } from '../../classes/translatable';
import { TypeTache } from '../../../tache/shared/classes/typeTache';
import { TypeTacheService } from '../../../tache/shared/services/typeTache.service';

@Component({
  selector: 'app-admin-list-type-categorie-tache',
  templateUrl: './admin-list-type-categorie-tache.component.html',
  styleUrls: ['./admin-list-type-categorie-tache.component.css'],
  animations: [imgCardDrop]
})
export class AdminListTypeCategorieTacheComponent implements OnInit {
    typesTache: TypeTache[];
    newCategorieTache = new TypeTache();
    selected = new FormControl(0);

    aclConfig: AclAccess;

    @Input()
    triggerReload: () => void;

    constructor(
        private typeTacheService: TypeTacheService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.typesTache = [];
    }


    getCategorieTache() {
        this.typesTache = [];
        this.typeTacheService.getTypeTache('metier_immo')
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.typesTache.push(new TypeTache(element));
                });
            }
        });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getCategorieTache();
        }
    }

    insertCategorieTache(typeTache: TypeTache) {
        typeTache.metier_gerance = false;
        typeTache.metier_projet = false;
        typeTache.metier_syndic = false;
        typeTache.metier_tous = false;
        typeTache.metier_transaction = false;
        typeTache.metier_immo = true;
        typeTache.metier_autres = false;
        this.typeTacheService.insertTypeTache(typeTache)
        .subscribe(retour => {
            if (retour.status === 201) {
                this.newCategorieTache = new TypeTache();
                this.alertService.success(TRANSLATE('Catégorie de tâche ajoutée avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateCategorieTache(typeTache: TypeTache) {
        this.typeTacheService.updateTypeTache(typeTache.id, typeTache)
        .subscribe(retour => {
            if (retour.status === 201) {
                this.alertService.success(TRANSLATE('Catégorie de tâche modifiée avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteCategorieTache(typeTache: TypeTache) {
        this.typeTacheService.deleteTypeTache(typeTache.id)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Catégorie de tâche supprimée avec succès'));
                this.getCategorieTache();
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

}
